import { useQuery } from "@tanstack/react-query";
import { Link, useSearchParams } from "react-router";
import { catalogueApi } from "../../api/catalogue";
import { PageWidth } from "../../components/catalogue/StoreShell";
import { usePageTitle } from "../catalogue/usePageTitle";
import { InquiryForm } from "./InquiryForm";

/** PRD screen 18, about one part: reached from its page, often when it's out of stock. */
export function InquiryRoute() {
  usePageTitle("Ask about a part");
  const id = Number(useSearchParams()[0].get("listing"));
  const listing = useQuery({ queryKey: ["catalogue", "listing", id], queryFn: () => catalogueApi.listing(id), enabled: id > 0 });

  return (
    <PageWidth className="max-w-[720px] pt-8">
      <h1 className="mb-2 type-h1 [font-size:var(--text-2xl)]">Ask us</h1>
      <p className="mb-6 type-body text-text-muted">Whether we have it, how many, how soon it can reach you. We reply by email or phone.</p>
      {id > 0 && listing.isPending ? (
        <p className="type-body text-text-muted">Loading…</p>
      ) : (
        // A part that won't load (no longer sold, a bad link) still leaves a general question.
        <InquiryForm key={listing.data?.id ?? 0} listing={listing.data} />
      )}
      {listing.data && (
        <Link to={`/listings/${listing.data.id}`} className="mt-6 inline-block type-label">
          Back to the part
        </Link>
      )}
    </PageWidth>
  );
}
